module.exports = __webpack_public_path__ + "img/blacklabel-logo-dark.55749c3a.svg";